import StepData from 'pattern/StepData.js';
import {RIGHT} from 'constants/hand-types.js';

export default superclass => class extends superclass  {
    cacheSize = 8;

    initCache(cacheSize=this.cacheSize) {
        this.cachedSteps = [];

        for (let i=0; i < cacheSize; i++) {
            let stepData = new StepData(undefined, undefined, undefined, this.track);
            stepData.loadDefaults();
            this.cachedSteps.push(stepData);
        }

        this.cacheIndex = 0;
    }

    getStep(step, transpose=step.transpose, duration=step.durationParameter.get(), useCache=true) {
        let stepToUse = undefined;
        if (useCache) {
            stepToUse = this.cachedSteps[this.cacheIndex];
            this.cacheIndex = (this.cacheIndex + 1) % this.cachedSteps.length;
        } else {
            stepToUse = new StepData(undefined, undefined, undefined, this.track);
        }
        stepToUse.transpose = transpose;
        stepToUse.velocity = step.velocity;
        stepToUse.on = step.on;
        stepToUse.leafNumber = step.leafNumber;
        stepToUse.duration = duration;
        if (step.voices) {
            stepToUse.voices = [... step.voices];
        }
        stepToUse.attack = step.attack;
        stepToUse.delays = step.delays;
        if (step.track) {
            stepToUse.track = step.track;
        }
        if (step.track ? step.track.instrument : this.track.instrument) {
            stepToUse.release = null; 
        } else {
            stepToUse.release = step.release;
        }
        stepToUse.start = step.start;
        stepToUse.hand = step.hand;
        stepToUse.isNewCycle = step.isNewCycle;
        stepToUse.chop = step.chop;
        stepToUse.pitchAttack = step.pitchAttack;
        stepToUse.pitchSustain = step.pitchSustain;
        stepToUse.pitchRelease = step.pitchRelease;
        stepToUse.pitchDecay = step.pitchDecay;
        stepToUse.slice = step.slice;
        stepToUse.reverse = step.reverse;
        stepToUse.panning = step.panning;
        stepToUse.selectedRecording = step.selectedRecording;
        stepToUse.palette = step.palette;
        stepToUse.auxEventA = step.auxEventA;
        stepToUse.auxEventB = step.auxEventB;
        stepToUse.auxEventC = step.auxEventC;
        stepToUse.auxEventD = step.auxEventD;
        return stepToUse;
    }
}
